// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"e757e433","118":"23f14821","320":"549213ef","787":"06d84b53"}[chunkId] + ".chunk.js";
};